/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';

import { toast } from 'react-toastify';
import { AxiosError, AxiosResponse } from 'axios';
import { useAsyncAction } from './hooks';
import { accountApi } from '../api';
import { AccountRecoveryRequest } from '../models/request';
import { BaseResponse, KeyValue } from '../models/common';
import {
  getCultureBrowser,
  getTranslateByKey,
  isSubDomainQualitas
} from '../services/utils';

interface ILoginFormOptions {
  onSuccess?: () => void;
}

export interface ILoginForm {
  usernameResetPassword: string;
}

export function useRecoveryPassword(
  translatesLocal: KeyValue[],
  options: ILoginFormOptions = {}
) {
  const cultureBrowser = getCultureBrowser();
  const { onSuccess } = options;
  const [serverErrors, setServerErrors] = useState<string[] | null>(null);
  const methods = useForm<ILoginForm>();
  const { handleSubmit } = methods;
  const [submit, submitInProgress] = useAsyncAction(
    (data: ILoginForm) => {
      setServerErrors(null);
      const request: AccountRecoveryRequest = {
        username: data.usernameResetPassword,
        idCultureBrowser: cultureBrowser,
        isSubDomainQualitas: isSubDomainQualitas()
      };
      return accountApi
        .accountRecoveryPasswordApi(request)
        .then((dataAxios: AxiosResponse<any>) => {
          const message = dataAxios.data.value;
          toast.success(message);
        })
        .catch((error: AxiosError<BaseResponse>) => {
          if (error.response && error.response.data) {
            const baseResponseError = error.response.data;
            if (
              baseResponseError.errorMessages &&
              baseResponseError.errorMessages.length > 0
            ) {
              setServerErrors(
                baseResponseError.errorMessages.map((x: KeyValue) => x.value)
              );
            }
          }
        });
    },
    [accountApi.accountRecoveryPasswordApi, setServerErrors, onSuccess]
  );

  return {
    submit: useMemo(() => handleSubmit(submit), [handleSubmit, submit]),
    submitInProgress: submitInProgress || methods.formState.isSubmitting,
    serverErrors,
    errors: methods.formState.errors,
    register: methods.register,
    watch: methods.watch
  };
}

